module.exports = __webpack_public_path__ + "img/client-2.8a9e3346.webp";